import httpClient from '../../services/http-client';
import { API_SUB_URL_PAYMENT } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { FETCH_DATA_REQUEST, FETCH_DATA_ERROR, LOAD_LIST_PAYMENT } from '../actionTypes';

export const apiLoadListPayment = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_PAYMENT}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_PAYMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};